/* eslint-disable max-len */
import * as React from "react";
import { ThemeBreakpoints, ThemePalette, ThemePaletteState, ThemeSize, } from "../../../../theme/_Types";
import { refreshMary } from "../../../../utils/General";
import * as I18n from "../../../../utils/translations/I18n";
import { Container } from "../../03-base/Container";
import { Div } from "../../03-base/Div";
import { FlexColumn } from "../../03-base/Flex/Column";
import { FlexRow } from "../../03-base/Flex/Row";
import { FillUp } from "../../04-helpers/FillUp";
import { Button } from "../../05-atoms/Button";
import { IconNames } from "../../05-atoms/Icon";
import { Alignment, ButtonsWrapper, Orientation } from "../../06-molecules/ButtonsWrapper";
import { Modal } from "../../06-molecules/Modal";
import { Navbar } from "../../07-organisms/Navbar";
import { NavbarIcon } from "../../07-organisms/Navbar/Icon";
import { NavbarStack, NavbarStackContent, NavbarStackRight } from "../../07-organisms/Navbar/Stack";
import { NavbarTitle } from "../../07-organisms/Navbar/Title";
export var ModalNotification = function (props) {
    var _a;
    var _b, _c, _d;
    return (React.createElement(Modal, { modalID: props.id, theme: { size: (_c = (_b = props === null || props === void 0 ? void 0 : props.theme) === null || _b === void 0 ? void 0 : _b.size) !== null && _c !== void 0 ? _c : ThemeSize.SMALL } },
        React.createElement(FlexRow, { isFixed: true },
            React.createElement(Navbar, { theme: props.theme ? (props.theme) : {
                    paletteState: ThemePaletteState.WARNING,
                } },
                React.createElement(NavbarStack, null,
                    React.createElement(NavbarStackContent, null,
                        React.createElement(NavbarTitle, null, props.title ? props.title :
                            I18n.getText("mary.09-views.03-modals.notification.title", "Warning"))),
                    React.createElement(NavbarStackRight, null,
                        React.createElement(NavbarIcon, null,
                            React.createElement(Button, { className: "scl-o-navbar__icon", icon: IconNames.TIMES, link: { onClick: props.onCloseModal } })))))),
        React.createElement(FlexRow, { theme: {
                palette: ThemePalette.CONTRAST_PRIMARY,
            }, isScrollable: true },
            React.createElement(FillUp, null,
                React.createElement(Container, { theme: {
                        padding: {
                            "": { y: 3 },
                            "md": { y: 4 },
                        },
                    } }, props.children ?
                    props.children : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "scl-b-h5 scl-b-h" }, I18n.getText("mary.09-views.03-modals.notification.message-label", "Message:")),
                    React.createElement("br", null),
                    React.createElement("p", null, (_d = props.message) !== null && _d !== void 0 ? _d : I18n.getText("mary.09-views.03-modals.notification.message-fallback", "No message."))))))),
        React.createElement(FlexRow, { isFixed: true },
            React.createElement(FlexColumn, { theme: {
                    palette: ThemePalette.CONTRAST_SECONDARY,
                } },
                React.createElement(Container, { theme: {
                        padding: {
                            "": { y: 3 },
                        },
                    } },
                    React.createElement(ButtonsWrapper, { orientations: (_a = {}, _a[ThemeBreakpoints.XS] = Orientation.HORIZONTAL, _a), alignment: Alignment.RIGHT },
                        props.refreshButton &&
                            React.createElement(Div, { style: { display: "flex" } },
                                React.createElement(Button, { theme: {
                                        palette: ThemePalette.CONTRAST_SECONDARY,
                                    }, link: { onClick: refreshMary } }, I18n.getText("mary.09-views.refresh-btn", "Refresh the page"))),
                        React.createElement(Div, { style: { display: "flex" } },
                            React.createElement(Button, { theme: {
                                    palette: ThemePalette.BRAND_ACCENT,
                                }, link: { onClick: props.onCloseModal } }, I18n.getText("mary.close", "Close")))))))));
};
